import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { createFirstAccessibleUrlTree } from '../navigation/sidebar-nav-items';
import { AccessControlService } from '../services/access-control.service';
import { AuthService } from '../services/auth.service';
import { LocationDataService } from '../services/location-data.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const accessControl = inject(AccessControlService);
  const router = inject(Router);
  const locationData = inject(LocationDataService);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  void locationData.ensureCacheWarm();

  return accessControl.ensureLoaded().pipe(
    map((loaded) => {
      if (!loaded) {
        return router.createUrlTree(['/login']);
      }

      if (state.url !== '/') {
        return true;
      }

      if (accessControl.hasModuleAccess('dashboard')) {
        return true;
      }

      return createFirstAccessibleUrlTree(router, accessControl);
    }),
  );
};
